import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { json, Link } from "react-router-dom";
import "./OrderCart.css";
import Sauces from "./Sauces/Sauces";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import jwtDecode from "jwt-decode";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import loadingImg from "./../../../Assets/Image/LoadingSpin.gif";
import { fetchCartData } from "../../../actions/actions";
import { useDispatch, useSelector } from "react-redux";
import { incrementItemCount } from "../../../reducers/cartCounterReducer";
import { initial, stubTrue } from "lodash";
import clock from "../../../Assets/Icons/clock.png";
import LeoImg from "../../../Assets/Image/Leo.png";
import Rating from "react-rating";
import warning from "../../../Assets/Icons/warning-sign.png";
import down from "../../../Assets/Icons/down.png";
import UnavavailableReasonModal from "../../../components/UnavailableReasonModal/UnavailableReasonModal";
import OutOfHourModal from "../../../components/OutOfHourModal/OutOfHourModal";
import { getFoodStatus } from "../../../utils/getFoodStatus";
import areMandatoryAddonsSelected from "../../../utils/getAllMandatoryAddon";
import areMandatoryOptionsSelected from "../../../utils/getAllMandatoryOption";
import BreakdownModal from "../BreakdownModal/BreakdownModal";

function OrderCart(props) {
  const [quantity, setQuantity] = useState(1);
  const [total, setTotal] = useState(props?.orderDetails?.itemBasePrice);
  const [saucestoggle, setsaucesToggle] = useState([]);
  const [saucesdis, setSaucesdis] = useState(false);
  const [options, setoptions] = useState([]);
  const [subOptions, setsubOptions] = useState([]);
  const [instruction, setInstruction] = useState("N/A");
  const [loading, setLoading] = useState(false);
  const [added, setAdded] = useState(false);
  const [userId, setUserId] = useState();
  const [sauceAdded, setSauceAdded] = useState(false);
  const [checkedItems, setCheckedItems] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [selectedSubOptions, setSelectedSubOptions] = useState({});
  const [activeAtFirst, setActiveAtFirst] = useState({});
  const [showOptions, setShowOptions] = useState({});
  const [checkboxOptions, setCheckboxOptions] = useState({});
  const [buttonOptionId, setButtonOptionId] = useState({});
  const [apiRequestObj, setApiRequestObj] = useState({});
  const [optionQuantities, setOptionQuantities] = useState({});
  const [subOptionWarnings, setSubOptionWarnings] = useState({});
  const [incrementType, setIncrementType] = useState("");
  const [newTotal, setNewTotal] = useState(0);
  const [addonQuantities, setAddonQuantities] = useState({});
  const [notLinkedAddonQuantity, setNotLinkedAddonQuantity] = useState(0);
  const [showBreakdownModal, setShowBreakdownModal] = useState(false);
  const [selectedAddonData, setSelectedAddonData] = useState([]);
  const [linkedOptionTotal, setLinkedOptionTotal] = useState(0);
  const [addonHybridTotalPrice, setAddonHybridTotalPrice] = useState(0);
  const [addonLinkedTotalPrice, setAddonLinkedTotalPrice] = useState(0);
  const [addonNotLinkedTotalPrice, setAddonNotLinkedTotalPrice] = useState(0);
  const [notCountableTotal, setNotCountableTotal] = useState(0);
  const [countableAddonTotal, setCountableTotalAddon] = useState(0);
  const [subOptionQuantity, setSubOptionQuantity] = useState(0);
  const [
    subOptionQuantityOptionCountable,
    setSubOptionQuantityOptionCountable,
  ] = useState(0);
  const [countableAddonOptionQuantity, setCountableAddonOptionQuantity] =
    useState(0);
  console.log(
    "open ordercart",
    subOptions,
    selectedSubOptions,
    subOptionQuantity,
    subOptionQuantityOptionCountable,
    addonQuantities
  );

  // making an object using existing addon
  useEffect(() => {
    const addOns = props?.orderDetails?.addOns;
    if (!Array.isArray(addOns) || addOns.length === 0) return;

    const visibilityMap = {};
    const allOptions = {};

    addOns.forEach((item) => {
      const shouldShow =
        !item.isCollapsibleOption && item.options && item.options.length <= 3;
      visibilityMap[item.id] = item?.isCountable ? true : shouldShow;

      allOptions[item.id] = true;
    });

    setShowOptions(visibilityMap);
    // setActiveAtFirst(allOptions);
  }, [props?.orderDetails?.addOns]);

  const dispatch = useDispatch();
  // const cartDataCount = useSelector((state) => state.cartReducer.cartItems);

  const handleShowBreakdownModal = () => {
    setShowBreakdownModal(true);
  };

  console.log(
    "response for addon: ",
    optionQuantities,
    checkboxOptions,
    selectedOptions
  );
  const handleCheckboxChange = (addOnId, optionId, isChecked) => {
    setCheckboxOptions((prev) => {
      const currentOptions = prev[addOnId] || [];
      if (isChecked) {
        // Add the optionId if it's checked
        return {
          ...prev,
          [addOnId]: [...currentOptions, optionId],
        };
      } else {
        // Remove the optionId if it's unchecked
        return {
          ...prev,
          [addOnId]: currentOptions.filter((id) => id !== optionId),
        };
      }
    });
    var updatedSuboptions = subOptions.filter((x) => x.optionId != optionId);
    // var oldSuboptions = subOptions.filter((x) => x.optionId == optionId);

    // var oldtotalPrice = oldSuboptions.reduce(
    //   (sum, current) => sum + (current.price || 0),
    //   0
    // );

    // var updatedPrice = total - oldtotalPrice;
    // setTotal(updatedPrice);
    if (!isChecked) {
      setoptions((prevOptions) =>
        prevOptions.filter((option) => option.id !== optionId)
      );
      setSelectedSubOptions((prev) => {
        const updated = { ...prev };
        delete updated[optionId];
        return updated;
      });
    }
    setsubOptions(updatedSuboptions);
  };

  // const handleRadioButtonChange = (addOnId, optionId) => {
  //   setSelectedOptions((prev) => ({
  //     ...prev,
  //     [addOnId]: optionId, // Update the selection for the specific addOnId
  //   }));
  // };

  const handleRadioButtonChange = (addOnId, optionId) => {
    setSelectedOptions((prev) => {
      const updatedOptions = { ...prev };

      if (updatedOptions[addOnId] === optionId) {
        // Deselect the option if it is already selected
        updatedOptions[addOnId] = [];
      } else {
        // Select the new option
        updatedOptions[addOnId] = optionId;
      }

      return updatedOptions;
    });
  };

  const handleButtonChange = (addOnId, optionId) => {
    setButtonOptionId((prev) => ({
      ...prev,
      [addOnId]: optionId, // Update the selection for the specific addOnId
    }));
  };
  // console.log("selectedSubOptions0", selectedSubOptions);
  const handleSubOptionChange = (
    optionId,
    subOptionId,
    shouldRemove = false
  ) => {
    if (!shouldRemove) {
      setSelectedSubOptions((prev) => {
        const currentSubOptionId = prev[optionId];

        // If the subOptionId already exists, remove it
        if (currentSubOptionId === subOptionId) {
          const { [optionId]: _, ...rest } = prev;
          return rest;
        }

        // Otherwise, add or update the subOptionId
        return {
          ...prev,
          [optionId]: subOptionId,
        };
      });
    } else {
      setSelectedSubOptions({});
    }
  };

  // const combineSelections = () => {
  //   const combined = { ...selectedOptions };

  //   // Merge checkboxOptions, appending them to the combined structure
  //   for (const addOnId in checkboxOptions) {
  //     if (checkboxOptions.hasOwnProperty(addOnId)) {
  //       combined[addOnId] = combined[addOnId]
  //         ? [combined[addOnId], ...checkboxOptions[addOnId]] // Combine with radio options
  //         : checkboxOptions[addOnId]; // Only checkboxes, no radio option for this addOn
  //     }
  //   }

  //   // Merge buttonOptionId similarly
  //   for (const addOnId in buttonOptionId) {
  //     if (buttonOptionId.hasOwnProperty(addOnId)) {
  //       combined[addOnId] = buttonOptionId[addOnId]; // Add the button option if available
  //     }
  //   }

  //   // Include selected subOptions
  //   for (const optionId in selectedSubOptions) {
  //     if (selectedSubOptions.hasOwnProperty(optionId)) {
  //       combined[optionId] = {
  //         ...combined[optionId],
  //         subOptionId: selectedSubOptions[optionId], // Add the selected subOption
  //       };
  //     }
  //   }

  //   return combined;
  // };

  const combineSelections = () => {
    const combined = { ...selectedOptions };

    // Add checkbox options
    for (const addOnId in checkboxOptions) {
      if (checkboxOptions.hasOwnProperty(addOnId)) {
        combined[addOnId] = combined[addOnId]
          ? [combined[addOnId], ...checkboxOptions[addOnId]]
          : checkboxOptions[addOnId];
      }
    }

    // Add button options
    for (const addOnId in buttonOptionId) {
      if (buttonOptionId.hasOwnProperty(addOnId)) {
        combined[addOnId] = buttonOptionId[addOnId];
      }
    }

    // Include preselected add-ons
    for (const addOnId in checkedItems) {
      if (checkedItems[addOnId] && !combined[addOnId]) {
        combined[addOnId] = []; // Mark as selected with no options or sub-options
      }
    }

    // Include sub-options
    for (const optionId in selectedSubOptions) {
      if (selectedSubOptions.hasOwnProperty(optionId)) {
        combined[optionId] = {
          ...combined[optionId],
          subOptionId: selectedSubOptions[optionId],
        };
      }
    }

    return combined;
  };

  // const generateOrderPayload = (apiResponse, selectedOptions) => {
  //   debugger;
  //   const userId = localStorage.getItem("gotasteClienttoken");
  //   const decoded = jwtDecode(userId);

  //   const orderPayload = {
  //     userId: decoded.UserId,
  //     restaurantId: apiResponse.restaurantId,
  //     foodItemId: apiResponse.id,
  //     foodItemQuantity: quantity,
  //     addOns: [],
  //   };

  //   setSubOptionWarnings({});

  //   apiResponse.addOns.forEach((addOn) => {
  //     const selectedOptionIds = selectedOptions[addOn.id];

  //     if (selectedOptionIds) {
  //       const matchedOptions = addOn.options
  //         .filter((option) => {
  //           if (Array.isArray(selectedOptionIds)) {
  //             return selectedOptionIds.includes(option.optionId);
  //           }
  //           return option.optionId === selectedOptionIds;
  //         })
  //         .map((option) => {
  //           const subOptionId = selectedSubOptions[option.optionId];
  //           const optionQuantity = optionQuantities[option.optionId] || 1; // Default to 1 if no quantity set

  //           if (!subOptionId) {
  //             setSubOptionWarnings((prevWarnings) => ({
  //               ...prevWarnings,
  //               [option.optionId]: `SubOption must be selected for option: ${option.optionName}`,
  //             }));
  //             return null;
  //           }
  //           // Clear the warning for this option
  //           setSubOptionWarnings((prevWarnings) => ({
  //             ...prevWarnings,
  //             [option.optionId]: "", // Clear warning for this specific option
  //           }));

  //           return {
  //             optionId: option.optionId,
  //             optionQuantity, // Add optionQuantity to the payload
  //             subOptionIds: [{ subOptionId }],
  //           };
  //         });

  //       if (matchedOptions.length > 0) {
  //         orderPayload.addOns.push({
  //           addOnId: addOn.id,
  //           addOnName: addOn.addOnName,
  //           options: matchedOptions,
  //         });
  //       }
  //     }
  //   });

  //   return orderPayload;
  // };

  // const generateOrderPayload = (apiResponse, selectedOptions) => {
  //   const userId = localStorage.getItem("gotasteClienttoken");
  //   const decoded = jwtDecode(userId);

  //   const orderPayload = {
  //     userId: decoded.UserId,
  //     restaurantId: apiResponse.restaurantId,
  //     foodItemId: apiResponse.id,
  //     foodItemQuantity: quantity,
  //     addOns: [],
  //   };

  //   setSubOptionWarnings({});

  //   apiResponse.addOns.forEach((addOn) => {
  //     const selectedOptionIds = selectedOptions[addOn.id];

  //     if (addOn.options.length === 0) {
  //       // If the add-on has no options, add it directly to the payload
  //       orderPayload.addOns.push({
  //         addOnId: addOn.id,
  //         addOnName: addOn.addOnName,
  //         options: [], // No options for this add-on
  //       });
  //     } else if (selectedOptionIds) {
  //       const matchedOptions = addOn.options
  //         .filter((option) => {
  //           if (Array.isArray(selectedOptionIds)) {
  //             return selectedOptionIds.includes(option.optionId);
  //           }
  //           return option.optionId === selectedOptionIds;
  //         })
  //         .map((option) => {
  //           const subOptionId = selectedSubOptions[option.optionId];
  //           const optionQuantity = optionQuantities[option.optionId] || 1; // Default to 1 if no quantity set

  //           if (!subOptionId) {
  //             setSubOptionWarnings((prevWarnings) => ({
  //               ...prevWarnings,
  //               [option.optionId]: `SubOption must be selected for option: ${option.optionName}`,
  //             }));
  //             return null;
  //           }
  //           // Clear the warning for this option
  //           setSubOptionWarnings((prevWarnings) => ({
  //             ...prevWarnings,
  //             [option.optionId]: "", // Clear warning for this specific option
  //           }));

  //           return {
  //             optionId: option.optionId,
  //             optionQuantity, // Add optionQuantity to the payload
  //             subOptionIds: [{ subOptionId }],
  //           };
  //         })
  //         .filter((option) => option !== null); // Filter out null values

  //       if (matchedOptions.length > 0) {
  //         orderPayload.addOns.push({
  //           addOnId: addOn.id,
  //           addOnName: addOn.addOnName,
  //           options: matchedOptions,
  //         });
  //       }
  //     }
  //   });

  //   return orderPayload;
  // };

  const generateOrderPayload = (apiResponse, selectedOptions) => {
    const userId = localStorage.getItem("gotasteClienttoken");
    const decoded = jwtDecode(userId);

    const orderPayload = {
      userId: decoded.UserId,
      restaurantId: apiResponse.restaurantId,
      foodItemId: apiResponse.id,
      foodItemQuantity: quantity,
      instruction: instruction,
      orderType: props.orderType,
      addOns: [],
    };

    setSubOptionWarnings({});

    apiResponse.addOns.forEach((addOn) => {
      const selectedOptionIds = selectedOptions[addOn.id];
      const isSelectedAddon =
        checkedItems[addOn.id] ||
        checkboxOptions[addOn.id]?.length > 0 ||
        buttonOptionId[addOn.id];

      if (isSelectedAddon) {
        // Add add-on even if no options or sub-options are selected
        const matchedOptions = addOn.options
          .filter((option) => {
            if (Array.isArray(selectedOptionIds)) {
              return selectedOptionIds.includes(option.optionId);
            }
            return option.optionId === selectedOptionIds;
          })
          .map((option) => {
            const subOptionId = selectedSubOptions[option.optionId];
            const optionQuantity = option.isCountableLinked
              ? quantity
              : optionQuantities[option.optionId] || 1;

            // Handle warnings for missing sub-options
            if (!subOptionId && option.requiresSubOption) {
              setSubOptionWarnings((prevWarnings) => ({
                ...prevWarnings,
                [option.optionId]: `SubOption must be selected for option: ${option.optionName}`,
              }));
              return null;
            }

            setSubOptionWarnings((prevWarnings) => ({
              ...prevWarnings,
              [option.optionId]: "", // Clear warning
            }));

            let subOptionTotalQuantity = 0;
            if (addOn.isCountable) {
              subOptionTotalQuantity = notLinkedAddonQuantity;
            } else if (option.isCountable) {
              subOptionTotalQuantity = subOptionQuantityOptionCountable;
            } else {
              subOptionTotalQuantity = 1;
            }

            return {
              optionId: option.optionId,
              optionQuantity: addOn.isCountable
                ? countableAddonOptionQuantity
                : optionQuantity,
              subOptionIds: subOptionId
                ? [{ subOptionId, subOptionQuantity: subOptionTotalQuantity }]
                : [],
            };
          })
          .filter((option) => option !== null);

        orderPayload.addOns.push({
          addOnId: addOn.id,
          addOnName: addOn.addOnName,
          // addOnQuantity: addOn.isCountableLinked ? quantity : addonQuantities[addOn.id],
          addOnQuantity: notLinkedAddonQuantity,
          options: matchedOptions,
        });
      }
    });

    console.log("APi request: ", orderPayload);

    return orderPayload;
  };

  useEffect(() => {
    if (props.orderDetails) {
      try {
        // Generate payload even if no options are selected yet
        const combinedSelections = combineSelections();
        const requestObj = generateOrderPayload(
          props.orderDetails,
          combinedSelections
        );
        setApiRequestObj(requestObj);
      } catch (error) {
        console.error(error.message);
        // toast.warning(error.message);
      }
    }
  }, [
    props.orderDetails,
    selectedOptions,
    checkboxOptions,
    buttonOptionId,
    selectedSubOptions,
    quantity,
    optionQuantities,
    instruction,
    props.orderType,
    subOptionQuantity,
  ]);

  // console.log("response from food card 2: ", apiRequestObj);

  useEffect(() => {
    setTotal(props.orderDetails.itemBasePrice);
    setNewTotal(props.orderDetails.itemBasePrice);
    setQuantity(1);
    setsaucesToggle([]);
  }, []);

  const addQuantity = () => {
    setIncrementType("plus");
    setQuantity(quantity + 1);
    // setTotal(
    //   (value) =>
    //     props.orderDetails.itemBasePrice * (quantity + 1) +
    //     (value - props.orderDetails.itemBasePrice)
    // );

    setTotal((value) => value + props.orderDetails.itemBasePrice);
  };
  // const removeQuantity = () => {
  //   // if (quantity > 0) {
  //   //   setQuantity((prevQuantity) => prevQuantity - 1);
  //   //   // setTotal((value) => props.orderDetails.itemBasePrice * (quantity - 1));
  //   //   setTotal(
  //   //     (value) =>
  //   //       props.orderDetails.itemBasePrice * (quantity - 1) +
  //   //       (value - props.orderDetails.itemBasePrice)
  //   //   );
  //   // }
  //   if (quantity > 0) {
  //     setQuantity((prevQuantity) => prevQuantity - 1);
  //     setTotal((value) => value - props.orderDetails.itemBasePrice);

  //   }
  // };

  const removeQuantity = () => {
    setIncrementType("minus");
    if (quantity > 0) {
      setQuantity((prevQuantity) => {
        const newQuantity = prevQuantity - 1;

        if (newQuantity === 0) {
          // Reset all add-ons to unchecked
          const resetCheckedItems = {};
          props.orderDetails.addOns.forEach((dt) => {
            resetCheckedItems[dt.id] = false;
          });
          setCheckedItems(resetCheckedItems);
        }

        return newQuantity;
      });

      setTotal((value) => {
        const newTotal = value - props.orderDetails.itemBasePrice;

        if (quantity === 1) {
          return 0;
        }

        return newTotal;
      });
    }
  };

  const skipMemoSetTotal = useRef(false);

  useMemo(() => {
    (() => {
      // contains all the selected addons irrespective of linked or not
      const selectedAddon = [];
      for (const property in checkedItems) {
        if (checkedItems[property] === true) {
          selectedAddon.push(property);
        }
      }

      // case when addon is linked
      const countableLinkedAddons = props.orderDetails.addOns.filter(
        (addon) =>
          selectedAddon.includes(addon.id) && addon.isCountableLinked === true
      );

      // case when addon is not linked
      const Addons = props.orderDetails.addOns.filter(
        (addon) =>
          selectedAddon.includes(addon.id) &&
          addon.isCountableLinked !== true &&
          addon.isCountable === false
      );

      // case when addon is not linked and is countable
      const countableAddons = props.orderDetails.addOns.filter(
        (addon) =>
          selectedAddon.includes(addon.id) &&
          addon.isCountableLinked !== true &&
          addon.isCountable === true
      );

      const optionIds = options.map((opt) => opt.id);

      const optionIdToAddonMap = new Map();
      props.orderDetails.addOns.forEach((addon) => {
        addon.options.forEach((option) => {
          optionIdToAddonMap.set(option.optionId, addon);
        });
      });

      // Get hybrid addon IDs to exclude from notCountableAddons
      const hybridAddonIds = new Set(
        props.orderDetails.addOns
          .filter((addOn) => {
            const linkedOptions = addOn.options.filter(
              (opt) => opt.isCountableLinked === true
            );
            const nonLinkedOptions = addOn.options.filter(
              (opt) => opt.isCountableLinked !== true
            );

            const isHybrid =
              linkedOptions.length > 0 && nonLinkedOptions.length > 0;

            const isAnyOptionSelected = addOn.options.some((opt) =>
              optionIds.includes(opt.optionId)
            );

            return isHybrid && isAnyOptionSelected;
          })
          .map((addOn) => addOn.id)
      );

      // case when addon is not linked and is not countable
      const notCountableAddons = props.orderDetails.addOns.filter(
        (addon) =>
          selectedAddon.includes(addon.id) &&
          addon.isCountableLinked !== true &&
          addon.isCountable !== true &&
          !hybridAddonIds.has(addon.id) // <-- Exclude hybrid addons
      );

      // case when option is linked
      const countableLinkedOptions = props.orderDetails.addOns.flatMap(
        (addOn) =>
          addOn.options.filter(
            (addOnOption) =>
              optionIds.includes(addOnOption.optionId) &&
              addOnOption.isCountableLinked === true
          )
      );

      // case when option is not linked
      const Options = props.orderDetails.addOns.flatMap((addOn) =>
        addOn.options.filter(
          (addOnOption) =>
            optionIds.includes(addOnOption.optionId) &&
            addOnOption.isCountableLinked !== true &&
            addOn.isCountable === false
        )
      );

      // case when addon is not linked and addon is countable
      const optionAddonCountable = props.orderDetails.addOns.flatMap((addOn) =>
        addOn.options.filter(
          (addOnOption) =>
            optionIds.includes(addOnOption.optionId) &&
            addOnOption.isCountableLinked !== true &&
            addOn.isCountable === true
        )
      );

      // case when addon is not linked and addons is not countable
      const optionAddonNotCountable = props.orderDetails.addOns.flatMap(
        (addOn) =>
          addOn.options.filter(
            (addOnOption) =>
              optionIds.includes(addOnOption.optionId) &&
              addOnOption.isCountableLinked !== true &&
              addOn.isCountable !== true
          )
      );

      let totalFood = 0;
      totalFood += props.orderDetails.itemBasePrice * quantity;

      // case when addon is linked
      let totalAddonLinked = 0;
      countableLinkedAddons.forEach((addon) => {
        totalAddonLinked += addon.basePrice * quantity;
      });

      // case when addon is not linked
      let totalAddon = 0;
      Addons.forEach((addon) => {
        const addonQuantity = addonQuantities[addon.id];
        if (addonQuantity) {
          totalAddon += addon.basePrice * addonQuantity;
        }
      });

      // case when addon is not linked and is countable
      let totalCountableAddon = 0;
      let countableAddonQuantity = 0;

      console.log("____aa", countableAddons, addonQuantities);

      countableAddons.forEach((addon) => {
        const addonQuantity = addonQuantities[addon.id] ?? 0;
        console.log("____ab", addonQuantity, addon);
        if (addonQuantity > 0) {
          console.log("____ac", addon.basePrice);
          totalCountableAddon += addon.basePrice * addonQuantity;
          countableAddonQuantity += addonQuantity;
          console.log("____ae", totalCountableAddon, countableAddonQuantity);
        }
      });

      console.log("____ad", countableAddonQuantity);

      setCountableTotalAddon(totalCountableAddon);

      // total for linked options
      let totalOptionLinked = 0;
      countableLinkedOptions.forEach((option) => {
        totalOptionLinked += option.basePrice * quantity;
      });
      setLinkedOptionTotal(totalOptionLinked);

      // total for not linked options
      let totalOption = 0;
      let notLinkedQuantity = 0;
      Options.forEach((option) => {
        const optionQuantity = optionQuantities[option.optionId];

        if (optionQuantity || optionQuantity === 0) {
          totalOption +=
            option.basePrice * (option.isCountable ? optionQuantity : 1);

          // If option is countable, add its quantity
          if (option.isCountable) {
            notLinkedQuantity += optionQuantity;
          }
          // If option is not countable, add 1 for selection
          else {
            notLinkedQuantity += 1;
          }
        }
      });

      // let totalOption = 0;
      // let notLinkedQuantity = 0;
      // Options.forEach((option) => {
      //   const optionQuantity = optionQuantities[option.optionId];
      //   if (optionQuantity) {
      //     totalOption += option.basePrice * optionQuantity
      //     notLinkedQuantity = optionQuantity
      //   }
      // });

      // total for options when addon is countable
      let totalOptionAddonCountable = 0;
      optionAddonCountable.forEach((option) => {
        const parentAddon = optionIdToAddonMap.get(option.optionId);
        if (parentAddon) {
          const addonQuantity = addonQuantities[parentAddon.id] || 1;
          totalOptionAddonCountable += option.basePrice * addonQuantity;
        }
      });

      // case when addon is not linked and is not countable
      let totalNotCountable = 0;
      notCountableAddons.forEach((addon) => {
        totalNotCountable += addon.basePrice * notLinkedQuantity;
      });

      let totalSubOptionPrice = 0;
      Object.entries(selectedSubOptions).forEach(
        ([optionId, selectedSubOptionId]) => {
          const parentAddon = optionIdToAddonMap.get(optionId);
          if (!parentAddon) return;

          const isAddonCountable = parentAddon.isCountable;
          const addonQuantity = addonQuantities[parentAddon.id] || 1;

          const option = parentAddon.options.find(
            (opt) => opt.optionId === optionId
          );
          if (!option) return;

          const matchedSubOption = option.subOptions?.find(
            (sub) => sub.subOptionId === selectedSubOptionId
          );
          if (!matchedSubOption) return;

          let subOptionQuantity = 1;
          if (isAddonCountable) {
            subOptionQuantity = addonQuantity;
          } else if (option.isCountable) {
            subOptionQuantity = optionQuantities[optionId] || 1;
            setSubOptionQuantityOptionCountable(subOptionQuantity);
          }

          setSubOptionQuantity(subOptionQuantity);
          totalSubOptionPrice += matchedSubOption.price * subOptionQuantity;
        }
      );

      const addOnData = [];

      props.orderDetails.addOns.forEach((addOn) => {
        const isAddonSelected = checkedItems[addOn.id] === true;
        if (!isAddonSelected) return;

        const baseAddOnPrice = addOn.basePrice;
        const addOnName = addOn.addOnName;

        // Find selected options within this addon
        const selectedOptions = addOn.options.filter((opt) =>
          optionIds.includes(opt.optionId)
        );

        const isAddonCountable = addOn.isCountable === true;
        const addonQuantity = isAddonCountable
          ? addonQuantities[addOn.id] || 1
          : 1;

        selectedOptions.forEach((option) => {
          const isLinked = option.isCountableLinked === true;

          // If addon is countable and options are not linked, option quantity should inherit addon quantity
          const optionQuantity = isLinked
            ? quantity
            : isAddonCountable
            ? addonQuantity
            : optionQuantities[option.optionId] || 1;

          setCountableAddonOptionQuantity(optionQuantity);

          const optionPrice = option.basePrice;
          const optionName = option.optionName;
          const optionTotalPrice = optionPrice * optionQuantity;

          const addonTotalPrice = baseAddOnPrice * addonQuantity;

          let selectedSubOptionData = null;
          const selectedSubOptionId = selectedSubOptions[option.optionId];
          if (selectedSubOptionId) {
            const matchedSubOption = (option.subOptions || []).find(
              (sub) => sub.subOptionId === selectedSubOptionId
            );
            if (matchedSubOption) {
              selectedSubOptionData = {
                subOptionId: matchedSubOption.subOptionId,
                name: matchedSubOption.subOptionName,
                price: matchedSubOption.price * optionQuantity,
                quantity: optionQuantity, // Set subOption quantity based on resolved option quantity
              };
            }
          }

          addOnData.push({
            addOnId: addOn.id,
            quantity: addonQuantity,
            addOnPrice: baseAddOnPrice,
            addonTotalPrice: addonTotalPrice,
            addOnName: addOnName,
            optionId: option.optionId,
            optionQuantity: optionQuantity,
            optionPrice: optionPrice,
            optionTotalPrice: optionTotalPrice,
            optionName: optionName,
            totalPrice:
              addonTotalPrice +
              optionTotalPrice +
              (selectedSubOptionData
                ? selectedSubOptionData.price * selectedSubOptionData.quantity
                : 0),
            subOption: selectedSubOptionData,
          });
        });
      });

      setSelectedAddonData(addOnData);

      const showTotalQuantity =
        countableLinkedOptions.length > 0 && Options.length > 0 ? true : false;
      // const totalAddonQuantity = showTotalQuantity ? notLinkedQuantity + quantity : countableLinkedOptions.length > 0 ? quantity : notLinkedQuantity;
      const totalAddonQuantity = showTotalQuantity
        ? notLinkedQuantity + quantity
        : countableLinkedOptions.length > 0
        ? quantity
        : countableAddonQuantity > 0
        ? countableAddonQuantity
        : notLinkedQuantity;
      setNotLinkedAddonQuantity(totalAddonQuantity);

      // Step 1: Detect hybrid add-ons that have both linked and non-linked options
      const hybridAddonsWithSelectedOptions = props.orderDetails.addOns.filter(
        (addOn) => {
          const linkedOptions = addOn.options.filter(
            (opt) => opt.isCountableLinked === true
          );
          const nonLinkedOptions = addOn.options.filter(
            (opt) => opt.isCountableLinked !== true
          );

          const isHybrid =
            linkedOptions.length > 0 && nonLinkedOptions.length > 0;

          if (!isHybrid) return false;

          // Step 2: Check if any option from this hybrid addon is selected
          const isAnyOptionSelected = addOn.options.some((opt) =>
            optionIds.includes(opt.optionId)
          );
          return isAnyOptionSelected;
        }
      );

      let totalHybridAddonPrice = 0;
      hybridAddonsWithSelectedOptions.forEach((addOn) => {
        totalHybridAddonPrice += addOn.basePrice * totalAddonQuantity;
      });

      setAddonHybridTotalPrice(totalHybridAddonPrice);
      setAddonLinkedTotalPrice(totalAddonLinked);
      setAddonNotLinkedTotalPrice(totalAddon);
      setNotCountableTotal(totalNotCountable);

      const totalPrice =
        totalFood +
        totalAddonLinked +
        totalOptionLinked +
        totalAddon +
        totalOption +
        totalCountableAddon +
        totalOptionAddonCountable +
        totalSubOptionPrice +
        totalHybridAddonPrice +
        totalNotCountable;
      console.log(
        "addon quantyit: ",
        totalFood,
        totalAddonLinked,
        totalOptionLinked,
        totalAddon,
        totalOption,
        totalCountableAddon,
        totalOptionAddonCountable,
        totalSubOptionPrice,
        totalHybridAddonPrice,
        totalNotCountable
      );

      if (!skipMemoSetTotal.current) {
        setNewTotal(totalPrice);
      } else {
        setTimeout(() => {
          skipMemoSetTotal.current = false;
        }, 0);
      }
    })();
  }, [
    quantity,
    checkedItems,
    options,
    optionQuantities,
    addonQuantities,
    selectedSubOptions,
  ]);

  console.log("____addonQuantities", addonQuantities);

  const saucestoggleHandler = (props) => {
    var list = [...saucestoggle];
    var index = list.findIndex((x) => x === props);

    if (index !== -1) {
      list.splice(index, 1);
    } else {
      list.push(props);
    }
    console.log(list);
    setsaucesToggle(list);
  };

  // useEffect(() => {
  //   const initialCheckedState = {};
  //   let initialTotalPrice = total;

  //   props.orderDetails.addOns.forEach((dt) => {
  //     if (dt.isCollapsibleOption === true) {
  //       initialCheckedState[dt.id] = false;
  //     } else if (dt.isCollapsibleOption === false) {
  //       const isChecked = dt.options.length < 4;
  //       initialCheckedState[dt.id] = isChecked;

  //       if (isChecked) {
  //         initialTotalPrice += dt.basePrice;
  //       }
  //     } else {
  //       initialCheckedState[dt.id] = false;
  //     }
  //   });

  //   setCheckedItems(initialCheckedState);
  //   setTotal(initialTotalPrice);
  // }, [props.orderDetails.addOns]);

  const [lessOptions, setLessOptions] = useState(false);

  useEffect(() => {
    const initialCheckedState = {};
    const preselectedAddOns = {};

    let initialTotalPrice = total;

    props.orderDetails.addOns.forEach((addOn) => {
      if (addOn.isCollapsibleOption === false) {
        // Preselect add-on when isCollapsibleOption is false
        initialCheckedState[addOn.id] = false;

        preselectedAddOns[addOn.id] = []; // Initialize as selected with no options or sub-options

        // Add the base price of preselected add-ons to the total
        if (addOn.options.length > 3) {
          initialTotalPrice += addOn.basePrice;
        } else {
          setLessOptions(true);
        }
      } else {
        // Default unchecked state for collapsible add-ons
        initialCheckedState[addOn.id] = false;
        preselectedAddOns[addOn.id] = [];
      }
    });

    // Update state with preselected add-ons and checked items
    setCheckedItems(initialCheckedState);
    setTotal(initialTotalPrice);

    // If there are preselected add-ons, add them to selectedOptions
    if (Object.keys(preselectedAddOns).length > 0) {
      setSelectedOptions((prev) => ({ ...prev, ...preselectedAddOns }));
    }
  }, [props.orderDetails.addOns]);

  useEffect(() => {
    if (options.length > 0 && subOptions.length > 0) {
      const newSubOptions = subOptions.filter((subOption) => {
        const isValid = options.some(
          (option) =>
            option.id === subOption.optionId &&
            option.addonId === subOption.addOnId
        );
        if (!isValid) {
          setTotal((prevValue) => prevValue - subOption.price);
        }
        return isValid;
      });

      // setsubOptions(newSubOptions);
    }
  }, [options, subOptions]);

  const [optionPrice, setOptionPrice] = useState([]);
  const saucesCallback = (
    id,
    amount,
    optionquantity,
    addonId,
    isRadio,
    shouldRemove
  ) => {
    if (options.length === 0) {
      setTotal((prevValue) => prevValue + amount);
      setOptionPrice((prev) => [...prev, { id: id, amount: amount }]);
      if (isRadio) {
        setoptions([{ id, price: amount, addonId }]);
      } else {
        setoptions((prevState) => [
          ...prevState,
          { id, price: amount, addonId },
        ]);
      }
    } else {
      const optionData = options.find(
        (x) => x.addonId == addonId && x.id == id
      );
      if (optionData) {
        console.log("optionPrice", optionPrice);
        const newOptions = options.filter((option) => option.id === id);
        if (shouldRemove) {
          const oprionP = optionPrice.find((x) => x.id == id);
          setoptions(options.filter((x) => x.id != id));
          setOptionPrice(optionPrice.filter((s) => s.id != id));

          const subOptionList = subOptions.filter((x) => x.optionId == id);
          const totalSum = subOptionList.reduce((accumulator, current) => {
            return accumulator + current.price;
          }, 0);

          setsubOptions(subOptions.filter((x) => x.optionId != id));
          setTotal((prevValue) => prevValue - oprionP.amount - totalSum);

          return;
        }

        // const oprionP = optionPrice.find((x) => x.id == id);

        // // setoptions([...newOptions, { id, price: amount, addonId }]);
        // setoptions(options.filter((x) => x.id != id));
        // setOptionPrice(optionPrice.filter((s) => s.id != id));
        // var subOptionList = subOptions.filter((x) => x.optionId == id);
        // var totalSum = subOptionList.reduce((accumulator, current) => {
        //   return accumulator + current.price;
        // }, 0);

        // var updatedSuboptions = subOptions.filter((x) => x.optionId != id);

        // setsubOptions(updatedSuboptions);
        // setTotal((prevValue) => prevValue - oprionP.amount - totalSum);
      } else {
        if (isRadio) {
          setoptions([{ id, price: amount, addonId }]);
        } else {
          setoptions((prevState) => [
            ...prevState,
            { id, price: amount, addonId },
          ]);
        }
        setTotal((prevValue) => prevValue + amount);
        setOptionPrice((prev) => [...prev, { id: id, amount: amount }]);
      }
    }

    // if (options.length > 0) {
    //   const prevsum = options.reduce((accumulator, object) => {
    //     return accumulator + object.amount * object.quantity;
    //   }, 0);
    //   var obj = options.find((x) => x.id == id && x.addonId == addonId);
    //   if (obj != undefined) {
    //     if (optionquantity == 0) {
    //       var index = options.findIndex(
    //         (x) => x.id === id && x.addonId == addonId
    //       );
    //       var latestList = subOptions.filter(
    //         (x) => x.optionId != id && x.addOnId != addonId
    //       );
    //       var prevtotalPrice = subOptions.reduce(
    //         (sum, item) => sum + item.price,
    //         0
    //       );
    //       var totalPrice = latestList.reduce(
    //         (sum, item) => sum + item.price,
    //         0
    //       );
    //       setsubOptions(latestList);
    //       var totalPriceData = total + totalPrice - prevtotalPrice;
    //       setTotal(totalPriceData);

    //       // Check if the object is found
    //       if (index !== -1) {
    //         // Remove the object using splice
    //         options.splice(index, 1);
    //       }
    //     } else {
    //       obj.quantity = optionquantity;
    //     }
    //   } else {
    //     options.push({
    //       id: id,
    //       amount: amount,
    //       quantity: optionquantity,
    //       addonId: addonId,
    //     });
    //   }
    //   const sum = options.reduce((accumulator, object) => {
    //     return accumulator + object.amount * object.quantity;
    //   }, 0);
    //   setTotal((value) => value + sum - prevsum);
    // } else {
    //   options.push({
    //     id: id,
    //     amount: amount,
    //     quantity: optionquantity,
    //     addonId: addonId,
    //   });
    //   setTotal((value) => value + amount);
    // }
  };
  const subOptionCallBack = (data) => {
    var subOptionsList = subOptions;
    console.log(data);
    console.log(subOptionsList);
    var objList = subOptionsList.filter(
      (x) => x.optionId === data.optionId && x.addOnId === data.addOnId
    );

    if (objList.length > 0) {
      var prevtotalPrice = objList.reduce((sum, item) => sum + item.price, 0);
      // var latestList = subOptions.filter(
      //   (x) => x.optionId != data.optionId && x.addOnId != data.addOnId
      // );

      var latestList = subOptions.filter(
        (x) =>
          !(x.optionId === data.optionId && x.subOptionId === data.subOptionId)
      );

      var checkList = subOptionsList.filter(
        (x) =>
          x.optionId === data.optionId &&
          x.addOnId === data.addOnId &&
          x.subOptionId === data.subOptionId
      );

      if (checkList.length == 0) {
        latestList.push(data);
      }

      setsubOptions(latestList);

      var totalPrice = latestList.reduce((sum, item) => sum + item.price, 0);

      var totalPriceData = total + totalPrice - prevtotalPrice;
      setTotal(totalPriceData);
    } else {
      var prevtotalPrice = subOptionsList.reduce(
        (sum, item) => sum + item.price,
        0
      );
      subOptionsList.push(data);

      var totalPrice = subOptionsList.reduce(
        (sum, item) => sum + item.price,
        0
      );
      setsubOptions(subOptionsList);
      var totalPriceData = total + totalPrice - prevtotalPrice;
      setTotal(totalPriceData);
    }
  };

  let gotasteClienttoken = localStorage.getItem("gotasteClienttoken");

  useEffect(() => {
    let decoded = {};

    if (gotasteClienttoken != null) {
      try {
        decoded = jwtDecode(gotasteClienttoken);
        // console.log(decoded);
      } catch (error) {
        console.log(error);
      }
    }

    if (decoded != null) {
      setUserId(decoded.UserId);
      // getUserChatPreview(decoded.UserId);
    }
  }, [gotasteClienttoken]);

  const onSubmit = async () => {
    const isMandatoryAddonExists = areMandatoryAddonsSelected(
      checkedItems,
      props.orderDetails.addOns
    );
    const isMandatoryOptionExists = areMandatoryOptionsSelected(
      options,
      props.orderDetails.addOns
    );

    if (!isMandatoryAddonExists || !isMandatoryOptionExists) {
      toast.warning("All the mandatory addon and option must be selected");
      return;
    }

    setLoading(true);
    var gotasteClienttokenData = localStorage.getItem("gotasteClienttoken");
    if (gotasteClienttokenData != null) {
      var decodedData = jwtDecode(gotasteClienttokenData);
      console.log(decodedData);

      var itemViewd = {
        id: "string",
        cartRestaurantMapperId: "string",
        itemId: props.itemId,
        qunatity: quantity,
        portionSize: 0,
        instruction: instruction,
        unitPrice: props.orderDetails.itemBasePrice,
        creationDate: new Date().toISOString(),
      };
      var optionSubOptionList = [];
      console.log("options", options);
      options.map((option) => {
        var optionViews = {
          id: option.id,
          cartRestaurantItemMapperId: "",
          optionId: option.id,
          quantity: option.quantity,
          unitPrice: option.price,
          addonId: option.addonId,
          creationDate: new Date().toISOString(), // You can set the creationDate as needed
        };
        var subOptionList = subOptions.filter(
          (x) => x.addOnId === option.addonId && x.optionId === option.id
        );

        var subOptionListViews = [];

        subOptionList.map((dt) => {
          var obj = {
            id: "string",
            cartRestaurantItemOptionmapperId: "string",
            subOptionId: dt.subOptionId,
            quantity: 1,
            unitPrice: dt.price,
            creationDate: new Date().toISOString(),
          };
          subOptionListViews.push(obj);
        });

        var optionSubOption = {
          optionView: optionViews,
          subOptionListView: subOptionListViews,
        };
        optionSubOptionList.push(optionSubOption);
      });
      console.log(optionSubOptionList);
      console.log(optionSubOptionList);
      var itemOptionSuboptionList = [];
      var obj = {
        itemView: itemViewd,
        OptionSubOptionList: optionSubOptionList,
      };
      itemOptionSuboptionList.push(obj);

      var cartInsertView = {
        Cart: {
          id: "string",
          userId: decodedData.UserId,
          isActive: true,
          creationDate: new Date().toISOString(),
        },
        cartRestaurantMapperList: [
          {
            cartRestaurantView: {
              id: "string",
              cartId: "string",
              restaurantId: props.selectedItem.restaurantId,
              creationDate: new Date().toISOString(),
            },
            itemOptionSuboptionList: itemOptionSuboptionList,
          },
        ],
      };

      console.log("cart Insert view", cartInsertView);

      const fetchDataAndAddToCart = async () => {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_SECRET}/api/Cart?userId=${userId}`
          );

          const data = response.data;

          const itemIdToCheck = props.itemId;
          console.log(itemIdToCheck);

          const isExist = data?.some((restaurant) =>
            restaurant.itemDetails.some((item) => item.itemId === itemIdToCheck)
          );

          console.log("exists here", isExist);

          if (!isExist) {
            await axios.post(
              process.env.REACT_APP_SECRET + "/api/Cart",
              cartInsertView
            );
            toast.success("Successfully Added to cart");
            // dispatch(fetchCartData(userId));
            setTimeout(() => {
              props.handleClose();
            }, 1000);
          } else {
            toast.warning("Item already exists in the cart");
          }
        } catch (error) {
          console.error("Error fetching or adding to cart:", error);
          toast.error("Something went wrong");
        } finally {
          setLoading(false);
        }
      };

      const AddToCart = async (reqBody) => {
        try {
          setLoading(true);
          const response = await axios.post(
            `${process.env.REACT_APP_SECRET}/api/Cart/InsertIntoCart`,
            reqBody
          );
          console.log("response from food card 5: ", response);
          if (response.data) {
            toast.success(response.data);
            dispatch(incrementItemCount(1));

            setTimeout(() => {
              props.handleClose();
            }, 2000);
          }
        } catch (error) {
          console.log("response from food card 4: ", error);
          if (
            error.response.data.status === 400 &&
            error.response.status === 400
          ) {
            toast.warning("all data is not available");
          } else {
            toast.warning(error.response.data);
          }
        } finally {
          setLoading(false);
        }
      };

      if (apiRequestObj) {
        /* Addon, option and sub-options validation */
        // Object.entries(checkedItems).forEach(([addOnId, value]) => {
        //   if (value === true) {
        //     alert("addon is selected");
        //     const addon = props.orderDetails.addOns.find(addon => addon.id === addOnId); //selected-addon
        //     if (addon && addon.options && addon.options.length > 0) {
        //       alert("Selected addon has options");
        //       if (Object.keys(combineSelections()).length !== 0) {
        //         Object.entries(combineSelections()).forEach(([AddOnId, OptionId]) => {
        //           // alert("AddOnId : " + AddOnId + ": OptionId : "  + OptionId);
        //           // alert(JSON.stringify(addon.options));
        //           addon.options.forEach(option => {
        //             if (option.optionId === OptionId) {
        //               alert("Option is selecteed");
        //             }
        //           });
        //         });
        //       } else {
        //         alert("You have to select an option");
        //       }

        //       /* checking for --- suboption -- start */
        //       // let hasSubOption = false;
        //       // addon.options.forEach(option => {
        //       //   if (option.subOptions && option.subOptions.length > 0) {
        //       //     hasSubOption = true;
        //       //   }
        //       // });
        //       // if (hasSubOption) {
        //       //   alert("This option has sub-options.");
        //       // } else {
        //       //   AddToCart(apiRequestObj);
        //       //   alert("This option has no sub-options...adding to cart");
        //       // }
        //       /* checking for --- suboption -- ends */
        //     } else {
        //       /* Addon has no option..directly adding to the cart */
        //       AddToCart(apiRequestObj);
        //     }
        //   }
        //   // else {
        //   //   alert("No addon is selected");
        //   //   // AddToCart(apiRequestObj);
        //   // }
        // });

        AddToCart(apiRequestObj);

        setTimeout(() => {
          if (props.setUpdateFoodData) {
            props.setUpdateFoodData(apiRequestObj.foodItemId);
          }
        }, 1500);
      }

      // fetchDataAndAddToCart();
    } else {
      toast.warning("Please login !!");
      setLoading(false);
    }
  };

  // const handleToggle = (dt) => {
  //   setCheckedItems((prevState) => {
  //     const isChecked = !prevState[dt.id];
  //     const updatedCheckedItems = {
  //       ...prevState,
  //       [dt.id]: isChecked,
  //     };

  //     // Adjust total price based on toggle
  //     setTotal(
  //       (prevPrice) =>
  //         isChecked
  //           ? prevPrice + dt.basePrice // Add basePrice if checked
  //           : prevPrice - dt.basePrice // Subtract basePrice if unchecked
  //     );

  //     return updatedCheckedItems;
  //   });
  // };

  const [showAddonMinus, setShowAddonMinus] = useState(false);

  useEffect(() => {
    setCheckedItems((prevState) => {
      const updatedCheckedItems = { ...prevState };

      props.orderDetails.addOns.forEach((dt) => {
        // Force toggle off for items with options > 3
        if (dt.options.length > 3) {
          updatedCheckedItems[dt.id] = false;
        }

        // Handle visibility for countable items
        if (dt.isCountable) {
          if (dt.options.length < 3) {
            setShowAddonMinus(true);
            // updatedCheckedItems[dt.id] = true; // Options not visible
          } else {
            updatedCheckedItems[dt.id] = false; // Options visible
          }
        }
      });

      return updatedCheckedItems;
    });
  }, [props, setCheckedItems]);

  const handleToggle = (dt) => {
    //initial State
    if (activeAtFirst[dt.id]) {
      setActiveAtFirst((prev) => ({
        ...prev,
        [dt.id]: false,
      }));

      if (showOptions[dt.id]) {
        setShowOptions((prev) => ({
          ...prev,
          [dt.id]: !prev?.[dt.id],
        }));
      }

      setCheckedItems((prevState) => ({
        ...prevState,
        [dt.id]: false,
      }));
      return;
    }

    // Later on Normal behaviour
    setActiveAtFirst((prev) => ({
      ...prev,
      [dt.id]: true,
    }));

    setShowOptions((prev) => ({
      ...prev,
      [dt.id]: !prev?.[dt.id],
    }));

    // If lessOptions is true, allow toggling but don't change the price or options
    if (lessOptions) {
      setCheckedItems((prevState) => ({
        ...prevState,
        [dt.id]: !prevState[dt.id], // Simply toggle the checked state
      }));
      setLessOptions(false);
      return;
    }

    // Proceed with normal behavior if lessOptions is false
    setCheckedItems((prevState) => {
      const isChecked = !prevState[dt.id];

      const updatedCheckedItems = {
        ...prevState,
        [dt.id]: isChecked,
      };

      // Adjust total price based on toggle
      setTotal(
        (prevPrice) =>
          isChecked
            ? prevPrice + dt.basePrice // Add basePrice if checked
            : prevPrice - dt.basePrice // Subtract basePrice if unchecked
      );

      // Update selectedOptions to add or remove the add-on
      if (isChecked) {
        setSelectedOptions((prevOptions) => ({
          ...prevOptions,
          [dt.id]: [], // Add the add-on with no options or sub-options
        }));
      } else {
        setSelectedOptions((prevOptions) => {
          const updatedOptions = { ...prevOptions };
          updatedOptions[dt.id] = []; // Remove the add-on entry
          return updatedOptions;
        });
      }

      return updatedCheckedItems;
    });
  };

  // console.log(sauceAdded);

  // const parentRef = useRef(null);
  const parentRef = useRef(null);

  const [buttonWidth, setButtonWidth] = useState("auto");

  useEffect(() => {
    const updateButtonWidth = () => {
      if (parentRef.current) {
        const parentWidth = parentRef.current.offsetWidth;
        setButtonWidth(`${parentWidth}px`);
      }
    };

    // Update on resize
    window.addEventListener("resize", updateButtonWidth);

    // Initial update
    updateButtonWidth();

    return () => {
      window.removeEventListener("resize", updateButtonWidth);
    };
  }, [parentRef]);

  // Showing preselected addon price into total
  useEffect(() => {
    if (props.orderDetails.addOns) {
      props.orderDetails.addOns.forEach((dt) => {
        if (dt.isCollapsibleOption) {
          setTotal((prevValue) => prevValue + dt.basePrice);
        }
      });
    }
  }, [props.orderDetails.addOns]);

  // addOn counter function and states

  const handleAddonQuantityChange = (type, addonId) => {
    setAddonQuantities((prevQuantities) => {
      const currentQuantity =
        prevQuantities[addonId] ||
        props.orderDetails.addOns.find((x) => x.id === addonId)?.minQuantity ||
        1;
      const addon = props.orderDetails.addOns.find((x) => x.id === addonId);

      if (!addon) return prevQuantities; // Ensure addon exists to avoid errors

      let newQuantity = currentQuantity;

      if (type === "plus") {
        if (newQuantity < addon.maxQuantity || addon.isCountableLinked) {
          if (!showAddonMinus && addon.isCountable) {
            newQuantity = addon.minQuantity;
            setShowAddonMinus(true);

            setTotal((prevPrice) => prevPrice + newQuantity * addon.basePrice);
          } else {
            newQuantity += addon.increamentalQuantity || 1;
            const quantityDifference = newQuantity - currentQuantity;
            const priceDifference = addon.basePrice * quantityDifference;

            setTotal((prevPrice) => prevPrice + priceDifference);
          }
        }
      } else if (type === "minus") {
        if (newQuantity > 0) {
          const decrement = addon.increamentalQuantity || 1;
          newQuantity = Math.max(0, newQuantity - decrement);

          if (newQuantity === 0) {
            setShowAddonMinus(false);
          }
        }

        const quantityDifference = newQuantity - currentQuantity;
        const priceDifference = addon.basePrice * quantityDifference;

        setTotal((prevPrice) => prevPrice + priceDifference);
      }

      // Update the total price based on the change in quantity

      // Manage add-on visibility based on quantity
      setCheckedItems((prevState) => {
        const updatedCheckedItems = { ...prevState };
        updatedCheckedItems[addonId] = newQuantity > 0;
        return updatedCheckedItems;
      });

      return {
        ...prevQuantities,
        [addonId]: newQuantity,
      };
    });
  };

  useEffect(() => {
    // Include the total from isCountable addOns
    const countableAddOnTotal = props.orderDetails.addOns
      .filter((addOn) => addOn.isCountable)
      .reduce((sum, addOn) => {
        const minQuantity = addOn.minQuantity || 0;
        const basePrice = addOn.basePrice || 0;
        return sum + minQuantity * basePrice;
      }, 0);

    // Set the state with the calculated values
    setTotal((prev) => prev + countableAddOnTotal);
  }, [props.orderDetails]);

  console.log("new total: ", newTotal);

  const handleSwitch = (value, dt) => {
    if (dt?.isCountableLinked === false) {
      skipMemoSetTotal.current = true;

      if (value) {
        setNewTotal((prev) => prev + dt.basePrice);
      } else {
        setNewTotal((prev) => prev - dt.basePrice);
      }
    }
  };

  const handleFirstAddonSelect = (dt) => {
    // Mark the addon as selected
    setCheckedItems((prev) => ({
      ...prev,
      [dt.id]: true,
    }));

    // Set initial quantity
    setAddonQuantities((prev) => ({
      ...prev,
      [dt.id]: dt.minQuantity || 1,
    }));
  };

  const [LinkedCountableQuantities, setLinkedCountableQuantities] = useState(
    {}
  );
  const [checkedLinkedCountableItems, setCheckedLinkedCountableItems] =
    useState({});

  const handleLinkedCountableDeselect = (id) => {
    setCheckedLinkedCountableItems((prev) => {
      const { [id]: _, ...rest } = prev;
      return rest;
    });

    setLinkedCountableQuantities((prevQuantities) => {
      const { [id]: _, ...restQuantities } = prevQuantities;
      return restQuantities;
    });

    setAddonQuantities((prevQuantities) => {
      const { [id]: _, ...restQuantities } = prevQuantities;
      return restQuantities;
    });

    setCheckedItems((prev) => ({
      ...prev,
      [id]: false,
    }));
  };

  // Increment/Decrement
  const handleFirstLinkedCountableSelect = (dt) => {
    const initialQuantity = quantity; // assuming you have `quantity` state holding main item quantity

    // 1. Mark as selected
    setCheckedLinkedCountableItems((prev) => ({ ...prev, [dt.id]: true }));

    // 2. Track quantity
    setLinkedCountableQuantities((prev) => ({
      ...prev,
      [dt.id]: initialQuantity,
    }));

    setAddonQuantities((prevQuantities) => ({
      ...prevQuantities,
      [dt.id]: initialQuantity,
    }));

    setCheckedItems((prev) => ({
      ...prev,
      [dt.id]: true,
    }));
  };

  console.log("newTotal", newTotal);

  return (
    <>
      {/* <dialog open></dialog> */}
      {/* {JSON.stringify(selectedSubOptions)} */}
      <style>
        {`

.fixedBtn{
 width: 100%;
    // position: fixed;
    // bottom: 4rem;
   padding-left:3rem
   padding-right:3rem
}






  @media only screen and (max-width: 688px) {
       .NewborderLinezero {
              margin-bottom: 4rem;
              // display:none;
         }
          
    .fixedBtn {
    position: fixed;
    bottom: 1rem;
    width: 90%;
    left: 0;
    right: 0;
    text-align: center;
    margin: auto;
              }
  }


   

          
        `}
      </style>
      <ToastContainer />
      <div
        className={`card ${
          props.from === "modal"
            ? "borderLinezero"
            : "OrderCartDetails Orderfoodcard"
        }  col-12  NewborderLinezero`}
      >
        <div className='card-body  pt-0 pb-0'>
          <div>
            {props.from === "modal" ? (
              ""
            ) : (
              <h4 className='textColor card-title'>
                Build your orders ({props.orderDetails.itemName})
              </h4>
            )}

            {/* Radio buttons start */}
            <div className='row toggleSection'>
              <div className='col-12 p-0' id='accordionExample'>
                {props.orderDetails.addOns !== undefined &&
                  props.orderDetails.addOns.map((dt, i) => (
                    <div key={dt.id + "_" + i}>
                      {/* {dt.options.length > 0 && ( */}
                      <div className='form-check form-switch d-flex justify-content-between toggleTittle '>
                        {/* Add-On Name */}
                        <label
                          className='form-check-label ordercartTitle'
                          htmlFor={dt.id}
                        >
                          <div>
                            <span>
                              {dt.addOnName ? dt.addOnName : <Skeleton />}
                            </span>
                            {dt.isMandatory && (
                              <span className='text-danger'>*</span>
                            )}
                            {dt.isCountableLinked && quantity > 0 ? (
                              <span
                                onClick={handleShowBreakdownModal}
                                className='pointer'
                              >
                                {" "}
                                X{quantity}
                              </span>
                            ) : !dt.isCountableLinked &&
                              !dt.isCountable &&
                              notLinkedAddonQuantity > 0 ? (
                              <span
                                onClick={handleShowBreakdownModal}
                                className='pointer'
                              >
                                {" "}
                                X{notLinkedAddonQuantity}
                              </span>
                            ) : null}
                          </div>
                        </label>
                        {/* Increment addons section */}

                        {/* --AddOn Radio Button-- */}
                        {/* {dt.options.length > 0 && ( */}
                        <div
                          className='d-flex align-content-center'
                          style={{
                            // justifyContent: 'space-between',
                            // flexDirection: 'row',
                            alignItems: "center",
                            gap: !(dt.isCountable && dt.isCountableLinked)
                              ? "10px"
                              : "0px",
                          }}
                        >
                          {dt.isCountable && dt.isCountableLinked && (
                            <div
                              className='d-flex align-items-center'
                              style={{ gap: "10px" }}
                            >
                              {checkedLinkedCountableItems[dt.id] ? (
                                <>
                                  <div
                                    onClick={() =>
                                      handleLinkedCountableDeselect(dt.id)
                                    }
                                    className='plusCircle'
                                  >
                                    <p>-</p>
                                  </div>
                                  <p>{quantity}</p>
                                  <div className='plusCircle disabled'>
                                    <p>+</p>
                                  </div>
                                  <p style={{ fontSize: ".9rem" }}>
                                    £{(dt.basePrice * quantity).toFixed(2)}
                                  </p>
                                </>
                              ) : (
                                <div
                                  onClick={() =>
                                    handleFirstLinkedCountableSelect(dt)
                                  }
                                  className='plusCircle'
                                >
                                  <p>+</p>
                                </div>
                              )}
                            </div>
                          )}

                          {dt.isCountable && !dt.isCountableLinked && (
                            <div
                              className='d-flex align-items-center'
                              style={{ gap: "10px" }}
                            >
                              {checkedItems[dt.id] ? (
                                // If selected, show - qty +
                                <>
                                  <div
                                    onClick={() =>
                                      handleAddonQuantityChange("minus", dt.id)
                                    }
                                    className='plusCircle'
                                  >
                                    <p>-</p>
                                  </div>
                                  <p>
                                    {addonQuantities[dt.id] ?? dt.minQuantity}
                                  </p>
                                  <div
                                    onClick={() =>
                                      handleAddonQuantityChange("plus", dt.id)
                                    }
                                    className='plusCircle'
                                  >
                                    <p>+</p>
                                  </div>
                                </>
                              ) : (
                                // If not selected yet, only show + icon to activate
                                <div
                                  onClick={() => handleFirstAddonSelect(dt)}
                                  className='plusCircle'
                                >
                                  <p>+</p>
                                </div>
                              )}
                            </div>
                          )}

                          <p
                            style={{
                              fontSize: ".9rem",
                              marginRight: dt.isCountable ? "20px" : "40px",
                            }}
                          >
                            {dt.basePrice &&
                            !(dt.isCountable && dt.isCountableLinked) ? (
                              (() => {
                                let finalPrice;

                                if (addonHybridTotalPrice > 0) {
                                  console.log("Using addonHybridTotalPrice");
                                  finalPrice = addonHybridTotalPrice;
                                } else if (addonLinkedTotalPrice > 0) {
                                  console.log("Using addonLinkedTotalPrice");
                                  finalPrice = addonLinkedTotalPrice;
                                } else if (addonNotLinkedTotalPrice > 0) {
                                  console.log("Using addonNotLinkedTotalPrice");
                                  finalPrice = addonNotLinkedTotalPrice;
                                }
                                // else if (notCountableTotal > 0) {
                                //   console.log("Using notCountableTotal");
                                //   finalPrice = notCountableTotal;
                                // }
                                else if (countableAddonTotal > 0) {
                                  const addonQty =
                                    addonQuantities?.[dt.id] ??
                                    dt.minQuantity ??
                                    1;
                                  finalPrice = dt.basePrice * addonQty;
                                  console.log(
                                    `Using countableAddonTotal for ${dt.addOnName} (id: ${dt.id})`,
                                    addonQty,
                                    "×",
                                    dt.basePrice,
                                    "=",
                                    finalPrice
                                  );
                                } else {
                                  console.log("Using dt.basePrice (default)");
                                  finalPrice = dt.basePrice;
                                }

                                return `£${finalPrice.toFixed(2)}`;
                              })()
                            ) : (
                              <Skeleton />
                            )}
                          </p>
                          {!dt.isCountable && (
                            <input
                              className='form-check-input toggleSwitch checkbox-gray'
                              type='checkbox'
                              id={dt.id}
                              disabled={
                                options.find((x) => x.addonId == dt.id) ==
                                undefined
                                  ? false
                                  : true
                                // selectedOptions[dt.id]?.length !== 0
                              }
                              // checked={dt.isCollapsibleOption}
                              checked={activeAtFirst[dt.id]}
                              // onClick={() => {
                              //   setCheckedItems((prevState) => ({
                              //     ...prevState,
                              //     [dt.id]: !prevState[dt.id], // Toggle the checked state for this specific checkbox
                              //   }));
                              // }}
                              onClick={(e) => {
                                handleToggle(dt);
                                handleSwitch(e.target.checked, dt);
                              }}
                            />
                          )}
                        </div>

                        {/* )} */}
                      </div>
                      {/* )} */}
                      {/* Option and suboption mapping */}
                      <div
                        className={`${
                          dt?.isCollapsibleOption === false ||
                          (dt?.isCollapsibleOption === true &&
                            dt?.options?.length <= 3) ||
                          (dt?.isCollapsibleOption === true &&
                            dt?.options?.length > 3 &&
                            showOptions[dt?.id])
                            ? "mt-2 wholeTable"
                            : "d-none"
                        }`}
                      >
                        <table className='table table-borderless orderCart'>
                          <thead>
                            {dt.options.length > 0 && (
                              <tr>
                                <th className='thTitle'>Select any</th>
                              </tr>
                            )}
                          </thead>
                          <tbody
                            className={`${
                              dt.optionButtonId === 5 ? "table-buttons" : ""
                            }`}
                          >
                            {dt.options.map((sauce, index) => (
                              <tr key={index}>
                                <Sauces
                                  checkedItems={checkedItems}
                                  options={options}
                                  setoptions={setoptions}
                                  setsubOptions={setsubOptions}
                                  name={sauce.optionName}
                                  price={sauce.basePrice}
                                  option={sauce}
                                  linkedOptionTotal={linkedOptionTotal}
                                  amount={sauce.basePrice}
                                  id={sauce.optionId}
                                  addonId={sauce.addOnId}
                                  isCountable={dt.isCountable}
                                  isCountableLinked={dt.isCountableLinked}
                                  sauceIsCountable={sauce?.isCountable}
                                  sauceIsCountableLinked={
                                    sauce.isCountableLinked
                                  }
                                  sauceIsMandatory={sauce.isMandatory}
                                  foodItemQuantity={quantity}
                                  optionButtonId={dt.optionButtonId}
                                  addOnName={dt.addOnName}
                                  setSauceAdded={setSauceAdded}
                                  saucesCallback={(
                                    id,
                                    amount,
                                    quantity,
                                    addonId,
                                    isRadio,
                                    shouldRemove
                                  ) => {
                                    saucesCallback(
                                      id,
                                      amount,
                                      quantity,
                                      addonId,
                                      isRadio,
                                      shouldRemove
                                    );
                                  }}
                                  subOptionCallBack={(data) => {
                                    subOptionCallBack(data);
                                  }}
                                  subOptions={sauce.subOptions}
                                  handleCheckboxChange={handleCheckboxChange}
                                  handleRadioButtonChange={
                                    handleRadioButtonChange
                                  }
                                  selectedOptions={selectedOptions}
                                  handleButtonChange={handleButtonChange}
                                  handleSubOptionChange={handleSubOptionChange}
                                  setOptionQuantities={setOptionQuantities}
                                  subOptionWarnings={
                                    subOptionWarnings[sauce.optionId]
                                  }
                                  checkboxOptions={checkboxOptions}
                                  lessOptions={lessOptions}
                                  notLinkedAddonQuantity={
                                    notLinkedAddonQuantity
                                  }
                                  selectedSubOptions={selectedSubOptions}
                                  subOptionQuantityOptionCountable={
                                    subOptionQuantityOptionCountable
                                  }
                                  setSelectedOptions={setSelectedOptions}
                                  optionQuantities={optionQuantities}
                                  setCheckboxOptions={setCheckboxOptions}
                                />
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      {/* End */}
                    </div>
                  ))}
              </div>
            </div>

            {/* Radio buttons end */}

            {/* Quantity Increment / decrement buttons */}
            <div className='pt-3 '>
              <strong className='ordercartTitle'>Quantity</strong>
              <div className='card border-0 '>
                <div className='card-body'>
                  <div className='row'>
                    <div className='col-12  d-flex justify-content-center'>
                      <button
                        disabled={quantity === 1}
                        className=' quantityBtn rounded-2 '
                        onClick={() => {
                          removeQuantity();
                        }}
                      >
                        -
                      </button>

                      <strong className='pt-3 ml-3'>{quantity}</strong>
                      <button
                        className=' quantityBtn  rounded-2 '
                        onClick={() => {
                          addQuantity();
                        }}
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* quantity end */}

            {props.showUnavailableReasonModal && (
              <UnavavailableReasonModal
                setShowUnavailableReasonModal={
                  props.setShowUnavailableReasonModal
                }
                foodItemName={props.orderDetails.itemName}
                foodUnavailableReason={props.orderDetails.foodUnavailableReason}
                sectionUnavailableReason={
                  props.orderDetails.sectionUnavailableReason
                }
                menuUnavailableReason={props.orderDetails.menuUnavailableReason}
              />
            )}

            {props.showOutOfHourModal && (
              <OutOfHourModal
                setShowOutOfHourModal={props.setShowOutOfHourModal}
                foodItemName={props.orderDetails.itemName}
              />
            )}

            {showBreakdownModal && (
              <BreakdownModal
                setShowBreakdownModal={setShowBreakdownModal}
                selectedAddonData={selectedAddonData}
              />
            )}

            <div className='pt-3'>
              <div className='col-12 mb-3' ref={parentRef}>
                <div className='pb-5'>
                  <h5 className=' titleColor'>Special instruction</h5>
                  <div className=''>
                    <input
                      type='text'
                      className='form-control inputField'
                      onChange={(e) => {
                        setInstruction(e.target.value);
                      }}
                    />
                  </div>
                </div>
                {/* Add to card button */}
                <div
                  className=' d-flex justify-content-evenly mt-5 fixedBtn'
                  style={{
                    width: buttonWidth,
                    position: "fixed",
                    bottom: "5%",
                  }}
                >
                  {loading ? (
                    <button
                      className=' btn btn-checkout'
                      type='button'
                      style={{ pointerEvents: "none", cursor: "no-drop" }}
                    >
                      <img
                        src={loadingImg}
                        className='img-fluid'
                        style={{ height: "1rem" }}
                        alt='loading'
                      />
                    </button>
                  ) : getFoodStatus(
                      props.orderDetails.isActive,
                      props.orderDetails.status
                    ) === "Unavailable" ? (
                    <button
                      className={`btn btn-checkout d-flex justify-content-center align-items-center ${
                        getFoodStatus(
                          props.orderDetails.isActive,
                          props.orderDetails.status
                        ) === "Unavailable"
                          ? "add-btn-disabled"
                          : ""
                      }`}
                      type='button'
                      onClick={() => props.setShowUnavailableReasonModal(true)}
                    >
                      <div className='icon-container icon-no-background'>
                        <img src={warning} alt='clock' />
                      </div>
                      <div className='mx-2'>Unavailable</div>
                      <div className='icon-container icon-no-background'>
                        <img src={down} alt='down' />
                      </div>
                    </button>
                  ) : getFoodStatus(
                      props.orderDetails.isActive,
                      props.orderDetails.status
                    ) === "Out of hour" ? (
                    <button
                      className={`btn btn-checkout d-flex justify-content-center align-items-center ${
                        getFoodStatus(
                          props.orderDetails.isActive,
                          props.orderDetails.status
                        ) === "Out of hour"
                          ? "add-btn-disabled"
                          : ""
                      }`}
                      type='button'
                      onClick={() => props.setShowOutOfHourModal(true)}
                    >
                      <div className='icon-container'>
                        <img src={clock} alt='warning' />
                      </div>
                      <div className='mx-2'>Out of hour</div>
                      <div className='icon-container icon-no-background'>
                        <img src={down} alt='down' />
                      </div>
                    </button>
                  ) : getFoodStatus(
                      props.orderDetails.isActive,
                      props.orderDetails.status
                    ) !== "Unavailable" ||
                    props?.orderDetails?.addOns.find(
                      (item) => item.isCountable === true
                    ) ? (
                    <button
                      className={`btn btn-checkout`}
                      type='button'
                      onClick={onSubmit}
                    >
                      Add for <strong>£ {newTotal.toFixed(2)}</strong>
                    </button>
                  ) : (
                    " "
                  )}

                  {/* <Link to="/Offers">
                  <button className=" AddTocart rounded-2" type="button ">
                    Offers
                  </button>
                </Link> */}
                </div>
                {/* End */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OrderCart;
